import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const usePricingVariationsSales = (params, options = {}) => {
  return useQuery(
    ["pricingVariationsSalesReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getIvPackageSales(), {
        params,
      });
      const composeResponse = {
        clinics: res.data.data.clinics,
        reportData: res.data.data.report_data,
        grouping: res.data.data.grouping,
        reportHeader: res.data.data.report_header,
        total: res.data.data.total,
      };
      return composeResponse;
    },
    options,
  );
};
